import { render, staticRenderFns } from "./DocumentPortalView.vue?vue&type=template&id=486b2e18&scoped=true&"
import script from "./DocumentPortalView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalView.vue?vue&type=style&index=0&id=486b2e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b2e18",
  null
  
)

export default component.exports